export const sum_amount_total_card=  function(res)
{
    var sum=0
    for(var i=0;i<res.length;i++)
    {
         sum+=(res[i].total_card*1);
    }
    return sum;
}
export const sum_amount_total_cash=  function(res)
{
    var sum=0
    for(var i=0;i<res.length;i++)
    {
         sum+=(res[i].total_cash*1);
    }
    return sum;
}
export const sum_discount_value=  function(res)
{
    var sum=0
    for(var i=0;i<res.length;i++)
    {
         sum+=(res[i].discount_value*1);
    }
    return sum;
}